// extracted by mini-css-extract-plugin
export default {"termsWrapper":"Terms_termsWrapper__yXxPi","termsContainer":"Terms_termsContainer__aFG2c"};